export const emailDialogID = 'email-dialog-id';
